import * as React from "react";

type Icon = React.ReactNode;

type IconProps = {
  icon: Icon;
  size: "sm" | "md";
};

const IconSizes = {
  sm: { size: 16, strokeWidth: 1.5 },
  md: { size: 24, strokeWidth: 2 },
};

const Icon = ({
  icon,
  size = "sm",
}: IconProps & React.ComponentProps<typeof icon>) => {
  const { size: iconSize, strokeWidth } = IconSizes[size];
  return React.cloneElement(icon, {
    size: iconSize,
    strokeWidth,
  });
};

export { Icon, IconSizes };
export type { Icon as IconType, IconProps };
